import React, { useState, useEffect } from 'react'

import cogniLogo from '../../images/cogni_logo.png'
import Workspace1 from '../../images/workspace_1.png'
import Workspace2 from '../../images/workspace_2.png'

import './newWorkspace.css'
import {
    DownArrow,
    PasswordEyeOpen,
    InfoIcon,
    PasswordEyeClose,
    TickIcon,
    CrossIcon,
    CrossIconForWorkspace,
} from '../common/icons'
import Downshift from 'downshift'
import Axios from 'axios'
import { Loader } from '../common/loader/loader'

const EmailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?=.{8,})/
const workspaceRegex = /^[a-z|0-9|A-Z]*$/

export const NewWorkspace = props => {
    const [dropdown, setDropdownValue] = useState({ show: false })
    const [formValues, setFormValues] = useState({
        workspace:
            props.mode == 'invitation_signup' ? props.match.params.ws : '',
        first_name: '',
        last_name: '',
        email: props.match.params.email,
        password: '',
        country: '',
        subscribeToNewsLetter: true,
    })
    const [enableButton, setEnableButton] = useState(false)
    const [invalidPassword, setInvalidPassword] = useState({
        show: false,
        msg: '',
    })
    const [invalidWorkspace, setInvalidWorkspace] = useState({
        show: false,
        error: false,
        isString: { isString: true, msg: '' },
    })
    const [invalidFirstName, setInvalidFirstName] = useState({
        show: false,
        msg: '',
    })
    const [invalidLastName, setInvalidLastName] = useState({
        show: false,
        msg: '',
    })
    const [invalidEmail, setInvalidEmail] = useState({ show: false, msg: '' })
    const [internalSereverError, closeInternalSereverError] = useState({
        show: false,
    })
    const [isLinkIsExpired, verificationLinkExpired] = useState(false)
    const [pageLoading, setPageIsLoading] = useState(false)

    useEffect(() => {
        const values = Object.assign({}, formValues)
        delete values.subscribeToNewsLetter
        const objectValues = Object.entries(values)
        const valid = objectValues.filter(x => x[1].length > 0)
        const validWorkspace = values.workspace.length > 1

        values.password.length > 0 && !PasswordRegex.test(values.password)
            ? setInvalidPassword({
                  ...invalidPassword,
                  show: true,
                  msg: 'Enter valid password',
              })
            : setInvalidPassword({ ...invalidPassword, show: false, msg: '' })

        setEnableButton(
            valid.length === objectValues.length &&
                EmailRegex.test(values.email) &&
                validWorkspace &&
                PasswordRegex.test(values.password) &&
                !invalidWorkspace.error &&
                invalidWorkspace.isString.isString &&
                values.first_name.length > 2 &&
                !invalidFirstName.show &&
                values.last_name.length > 0 &&
                !invalidLastName.show
        )
    }, [formValues, invalidWorkspace, invalidFirstName, invalidLastName])

    //validate workspace name
    if (props.mode !== 'invitation_signup') {
        useEffect(() => {
            if (
                formValues.workspace.length > 1 &&
                workspaceRegex.test(formValues.workspace)
            ) {
                Axios.get(
                    process.env.REACT_APP_AUTH_VERIFY_WORKSPACE_URL +
                        '/' +
                        formValues.workspace
                )
                    .then(success => {
                        success.data.exists === true
                            ? setInvalidWorkspace({
                                  ...invalidWorkspace,
                                  show: true,
                                  error: true,
                                  isString: {
                                      isString: true,
                                      msg: 'Workspace already exists',
                                  },
                              })
                            : setInvalidWorkspace({
                                  ...invalidWorkspace,
                                  show: true,
                                  error: false,
                                  isString: {
                                      isString: true,
                                      msg: 'Only alphanumeric without space',
                                  },
                              })
                    })
                    .catch(err => {
                        setInvalidWorkspace({
                            ...invalidWorkspace,
                            show: true,
                            error: true,
                        })
                    })
            } else {
                setInvalidWorkspace({
                    ...invalidWorkspace,
                    show: false,
                    error: false,
                })
            }
        }, [formValues.workspace])
    }

    const callAPI = () => {
        const submitURL =
            props.mode === 'invitation_signup'
                ? process.env.REACT_APP_AUTH_INVITATION_SIGNUP
                : process.env.REACT_APP_AUTH_CREATE_WORKSPACE_URL
        let req = Object.assign({}, formValues)

        req = {
            ...req,
            workspace: req.workspace.toLowerCase(),
            first_name:
                req.first_name.charAt(0).toUpperCase() +
                req.first_name.slice(1),
            last_name:
                req.last_name.charAt(0).toUpperCase() + req.last_name.slice(1),
            token: props.match.params.verificationId,
        }

        setPageIsLoading(true)
        Axios.put(submitURL, req)
            .then(success => {
                window.location =
                    process.env.REACT_APP_AUTH_REDIRECT + '?showtour=true'
            })
            .catch(err => {
                if (err.response.status === 403) {
                    setInvalidEmail({ show: true, msg: err.response.data })
                } else if (err.response.status === 401) {
                    if (err.response.data.code === 'INVALID_TOKEN') {
                        verificationLinkExpired(true)
                    } else {
                        setInvalidEmail({ show: true, msg: err.response.data })
                    }
                } else if (err.response.status === 400) {
                    setInvalidWorkspace({
                        ...invalidWorkspace,
                        show: true,
                        error: false,
                        isString: { isString: true, msg: err.response.data },
                    })
                } else {
                    closeInternalSereverError({ show: true })
                }
                setPageIsLoading(false)
            })
    }

    return pageLoading ? (
        <Loader.PageLoader show={true}></Loader.PageLoader>
    ) : (
        <Wrapper>
            <Header
                internalSereverError={internalSereverError}
                closeInternalSereverError={closeInternalSereverError}
                showSignUpLinkIsInvalid={isLinkIsExpired}
                onSignUpLinkInvalidClose={() => verificationLinkExpired(false)}
            />
            <ChildWrapper>
                <Inputs
                    formValues={formValues}
                    setFormValues={setFormValues}
                    invalidPassword={invalidPassword}
                    invalidWorkspace={invalidWorkspace}
                    invalidFirstName={invalidFirstName}
                    setInvalidWorkspace={setInvalidWorkspace}
                    invalidLastName={invalidLastName}
                    setInvalidFirstName={setInvalidFirstName}
                    setInvalidLastName={setInvalidLastName}
                    invalidEmail={invalidEmail}
                    mode={props.mode}
                />

                <DropDown
                    dropdown={dropdown}
                    setDropdownValue={setDropdownValue}
                    formValues={formValues}
                    setFormValues={setFormValues}
                />
                <CheckBox
                    formValues={formValues}
                    setFormValues={setFormValues}
                />
                <SubmitButton enableButton={enableButton} callAPI={callAPI} />
            </ChildWrapper>
        </Wrapper>
    )
}

function Wrapper(props) {
    return (
        <div className="login_bg_height workspace">
            <div className="login_bg_width">
                <div className="row">{props.children}</div>
            </div>
        </div>
    )
}

function ChildWrapper(props) {
    return (
        <div className="col-md-6 col-lg-6 login_bg_width_left_right">
            <div className="row login_bg_width_left_right_form">
                {props.children}
            </div>
        </div>
    )
}

function Header(props) {
    const {
        closeInternalSereverError,
        internalSereverError,
        showSignUpLinkIsInvalid,
        onSignUpLinkInvalidClose,
    } = props

    return (
        <React.Fragment>
            {internalSereverError.show && (
                <section className="container login_acc_message">
                    <p>
                        Something went wrong please try again after some time.
                    </p>
                    <span
                        onClick={() =>
                            closeInternalSereverError({ show: false })
                        }
                    >
                        <CrossIconForWorkspace />
                    </span>
                </section>
            )}
            {showSignUpLinkIsInvalid && (
                <section className="container login_acc_message">
                    <p>
                        Your Verification Link is Expired Or Invalid 😱. Don't
                        worry, Please Try to{' '}
                        <a href={process.env.REACT_APP_AUTH_UI_SIGNUP_URL_ABS}>
                            signup
                        </a>{' '}
                        again 😊.
                    </p>
                    <span onClick={() => onSignUpLinkInvalidClose()}>
                        <CrossIconForWorkspace />
                    </span>
                </section>
            )}
            <div className="col-md-6 col-lg-6 login_bg_width_left">
                <img
                    className="centerImage"
                    src={cogniLogo}
                    alt="Assistant"
                    title="Assistant"
                />
                <h2>
                    Welcome to <span> Workativ Assistant</span>
                </h2>
                <p>
                    Create your workspace to get started with Workativ
                    Assistant.
                </p>
                <div className="left_bottom_img">
                    <img
                        src={Workspace1}
                        align="middle"
                        alt="Workspace IMG"
                        title="Workspace IMG"
                    />
                    <img
                        src={Workspace2}
                        align="middle"
                        alt="Workspace IMG"
                        title="Workspace IMG"
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

function Inputs(props) {
    const [isEyeOpen, setisEyeOpen] = useState(false)

    const {
        formValues,
        setFormValues,
        invalidPassword,
        invalidWorkspace,
        invalidFirstName,
        setInvalidWorkspace,
        invalidLastName,
        setInvalidFirstName,
        setInvalidLastName,
        invalidEmail,
    } = props

    function handleInput(e) {
        if (e.target.id === 'workspace' && props.mode !== 'invitation_signup') {
            !workspaceRegex.test(e.target.value)
                ? setInvalidWorkspace({
                      ...invalidWorkspace,
                      isString: {
                          isString: false,
                          msg: 'Only alphanumeric without space',
                      },
                  })
                : setInvalidWorkspace({
                      ...invalidWorkspace,
                      isString: {
                          isString: true,
                          msg: 'Only alphanumeric without space',
                      },
                  })
        } else if (e.target.id === 'first_name') {
            workspaceRegex.test(e.target.value)
                ? e.target.value.length > 0 && e.target.value.length < 3
                    ? setInvalidFirstName({
                          ...invalidFirstName,
                          show: true,
                          msg: 'Min 3 characters',
                      })
                    : setInvalidFirstName({ ...invalidFirstName, show: false })
                : setInvalidFirstName({
                      ...invalidFirstName,
                      show: true,
                      msg: 'Use Only alphabets',
                  })
        } else if (e.target.id === 'last_name') {
            workspaceRegex.test(e.target.value)
                ? e.target.value.length === 0
                    ? setInvalidLastName({
                          ...invalidLastName,
                          show: true,
                          msg: 'Min 1 character',
                      })
                    : setInvalidLastName({ ...invalidLastName, show: false })
                : setInvalidLastName({
                      ...invalidLastName,
                      show: true,
                      msg: 'Use Only alphabets',
                  })
        }
        setFormValues({ ...formValues, [`${e.target.id}`]: e.target.value })
    }

    return (
        <React.Fragment>
            <div
                className={
                    !invalidWorkspace.isString.isString ||
                    invalidWorkspace.error
                        ? 'form-group form-group_error worksapce_width'
                        : 'form-group worksapce_width'
                }
            >
                <label htmlFor="text">Name your workspace</label>
                {(!invalidWorkspace.isString.isString ||
                    invalidWorkspace.error) && (
                    <span>{invalidWorkspace.isString.msg}</span>
                )}
                <input
                    type="text"
                    className="form-control"
                    id="workspace"
                    maxLength={20}
                    disabled={props.mode === 'invitation_signup'}
                    autoCapitalize={false}
                    style={{ textTransform: 'lowercase' }}
                    placeholder="Enter workspace name..."
                    value={formValues.workspace}
                    onChange={handleInput}
                />
                {invalidWorkspace.show &&
                    invalidWorkspace.isString.isString && (
                        <div
                            className={
                                invalidWorkspace.error
                                    ? 'workspace-name-div error'
                                    : 'workspace-name-div'
                            }
                        >
                            {invalidWorkspace.error ? (
                                <CrossIcon />
                            ) : (
                                <TickIcon />
                            )}
                        </div>
                    )}
                <span className="workspace_buton">
                    assistant.workativ.com/workspace/
                </span>
            </div>

            <div className="col-lg-6 pl-0">
                <div
                    className={
                        invalidFirstName.show
                            ? 'form-group form-group_error'
                            : 'form-group'
                    }
                >
                    <label htmlFor="email">First Name</label>
                    {invalidFirstName.show && (
                        <span>{invalidFirstName.msg}</span>
                    )}
                    <input
                        type="text"
                        maxLength={20}
                        className="form-control"
                        id="first_name"
                        placeholder="Enter your first name..."
                        value={formValues.first_name}
                        onChange={handleInput}
                        style={{ textTransform: 'capitalize' }}
                    />
                </div>
            </div>

            <div className="col-lg-6 pr-0">
                <div
                    className={
                        invalidLastName.show
                            ? 'form-group form-group_error'
                            : 'form-group'
                    }
                >
                    <label htmlFor="email">Last Name</label>
                    {invalidLastName.show && <span>{invalidLastName.msg}</span>}
                    <input
                        type="text"
                        maxLength={20}
                        className="form-control"
                        id="last_name"
                        placeholder="Enter your last name"
                        value={formValues.last_name}
                        onChange={handleInput}
                        style={{ textTransform: 'capitalize' }}
                    />
                </div>
            </div>

            <div
                className={
                    !invalidEmail.show
                        ? 'form-group workspace_eamil'
                        : 'form-group_error form-group workspace_eamil'
                }
            >
                <label htmlFor="email">Email ID</label>
                {invalidEmail.show && <span>{invalidEmail.msg}</span>}
                <input
                    type="text"
                    className="form-control"
                    id="email"
                    placeholder="Enter your email id..."
                    value={formValues.email}
                    onChange={handleInput}
                    disabled
                />
            </div>

            <div
                className={
                    invalidPassword.show
                        ? 'form-group_error form-group workspace_eamil'
                        : 'form-group workspace_eamil'
                }
            >
                <label htmlFor="pwd">Password</label>
                {invalidPassword.show && <span>{invalidPassword.msg}</span>}
                <span
                    tooltip="Include 1 special character, number, capital letter and small letter with min 8 and max 12 characters"
                    flow="right"
                    className="first-span"
                >
                    <InfoIcon />
                </span>
                <input
                    type={!isEyeOpen ? 'password' : 'text'}
                    maxLength={12}
                    className="form-control"
                    id="password"
                    placeholder="Enter your passowrd..."
                    value={formValues.password}
                    onChange={handleInput}
                />
                <span onClick={() => setisEyeOpen(!isEyeOpen)}>
                    {isEyeOpen ? <PasswordEyeOpen /> : <PasswordEyeClose />}
                </span>
            </div>
        </React.Fragment>
    )
}

function DropDown(props) {
    const [countryArray, setCountryArray] = useState([])

    const [search, setSearch] = useState('')

    const { dropdown, setDropdownValue } = props

    const { formValues, setFormValues } = props

    useEffect(() => {
        Axios.get(process.env.REACT_APP_AUTH_COUNTRY_URL)
            .then(success => success.data)
            .then(setCountryArray)
            .catch(err => {
                console.log('getting countries error', err)
            })
    }, [])
    return (
        <div className="form-group">
            <label htmlFor="text">Country</label>
            <input
                type="text"
                className="form-control"
                id="text"
                placeholder="Choose country"
                value={
                    formValues.country != '' && countryArray.length
                        ? countryArray
                              .filter(e => e.ISOcode == formValues.country)
                              .pop().name
                        : ''
                }
                onClick={() => setDropdownValue({ show: true })}
            />
            <div
                className="dropdown_down_arrowslot"
                onClick={() => setDropdownValue({ show: true })}
            >
                <DownArrow />
            </div>

            {dropdown.show && (
                <Downshift
                    isOpen={true}
                    onOuterClick={() => setDropdownValue({ show: false })}
                >
                    {() => (
                        <div className="dropdown_right_entity">
                            <label className="form-input">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="text"
                                    value={search}
                                    onChange={e => setSearch(e.target.value)}
                                    placeholder="Search Country..."
                                    autoFocus={true}
                                />
                            </label>
                            <div className="dialog_scroll_list">
                                <ul>
                                    {countryArray
                                        .filter(e =>
                                            e.name
                                                .toLowerCase()
                                                .includes(search.toLowerCase())
                                        )
                                        .map((country, i) => {
                                            return (
                                                <li
                                                    key={i}
                                                    onClick={() => {
                                                        setFormValues({
                                                            ...formValues,
                                                            country:
                                                                country.ISOcode,
                                                        })
                                                        setDropdownValue({
                                                            show: false,
                                                        })
                                                    }}
                                                >
                                                    {country.name}
                                                </li>
                                            )
                                        })}
                                </ul>
                            </div>
                        </div>
                    )}
                </Downshift>
            )}
        </div>
    )
}

function CheckBox(props) {
    const { formValues, setFormValues } = props

    return (
        <div className="form-group checkbox_workspace">
            <input
                className="form-check-input"
                type="checkbox"
                checked={formValues.subscribeToNewsLetter}
                onChange={e =>
                    setFormValues({
                        ...formValues,
                        subscribeToNewsLetter: !formValues.subscribeToNewsLetter,
                    })
                }
            />{' '}
            <span>
                Yes! Send me news and offers from Workativ about products,
                events, and more.
            </span>
        </div>
    )
}

function SubmitButton(props) {
    const { enableButton, callAPI } = props

    return (
        <React.Fragment>
            <div className="workspace_p">
                <p>
                    By clicking below, you agree to the Workativ Assistant{' '}
                    <a
                        href="https://workativ.com/terms"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        {' '}
                        Terms of Services
                    </a>{' '}
                    and
                    <a
                        href="https://workativ.com/privacy"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        {' '}
                        Privacy Policy.
                    </a>
                </p>
            </div>
            <button
                className="workspace_button btn btn-primary"
                disabled={!enableButton}
                type="submit"
                onClick={() => callAPI()}
            >
                Submit
            </button>
        </React.Fragment>
    )
}
